
    import I18n from 'i18nObj';
    
      import 'translations/home_page_prompt';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('home_page_prompt');
  